/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2022
 * @flow
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import notificationGif from '../../../../assets/images/Fireboard/bell.gif';
import notificationUnSelectedUnFilled from '../../../../assets/images/Fireboard/notificationfilled_white.png';
import notificationUnSelectedFilled from '../../../../assets/images/Fireboard/notificationfilled_orange.png';
import snooze from '../../../../assets/images/Fireboard/snoozeSleep.png';
import mp3File from '../../../../resources/sound.mp3';
import EventEmitter from '../../../../util/event-emitter';
import classes from './NotificationBell.module.css';

const audio = new Audio(mp3File);
audio.loop = true;

const NotificationBell = props => {
  const {
    showNotifications,
    notificationCount,
    notificationControlEnabled,
    snoozeEnabled,
    snoozeNotifications,
    totalNotificationsCount,
    setNotifications,
  } = props;

  const [blinkAnim, setBlinkAnim] = useState(false);

  useEffect(() => {
    if (notificationControlEnabled && notificationCount > 0) {
      if (!snoozeEnabled) {
        if (!window.ReactNativeWebView)
          audio.play();
        else
          EventEmitter.playAudio(true);
      }
      setBlinkAnim(true);

      return () => {
        if (!window.ReactNativeWebView)
          audio && audio.pause();
        else
          EventEmitter.playAudio(false);
        setBlinkAnim(false);
      };
    }
  }, [notificationControlEnabled, snoozeEnabled, notificationCount]);

  const getNotificationImage = () => {
    if (showNotifications) {
      if (notificationCount > 0) {
        return notificationUnSelectedFilled;
      }
      return notificationUnSelectedUnFilled;
    }
    if (notificationCount > 0) {
      return notificationUnSelectedFilled;
    }
    return notificationUnSelectedUnFilled;
  };

  const getSnoozeIcon = () => {
    if (notificationControlEnabled && notificationCount > 0 && !snoozeEnabled) {
      return (
        <div className={classes.col2SubViewBell} style={{ width: '4%' }}>
          <img alt="snooze" className={classes.snoozeIcon} src={snooze} onClick={snoozeNotifications} />
        </div>
      );
    }
    return (
      <div className={classes.col2SubViewBell} style={{ width: '4%' }} />
    );
  };

  const bellIcon = blinkAnim ? notificationGif : getNotificationImage();

  return (
    <React.Fragment>
      <div className={classes.col2SubViewBell} style={{ marginLeft: '4vw' }}>
        <img onClick={setNotifications} className={classes.bellIcon} src={bellIcon} key={bellIcon} alt="source" />
        <div className={classes.notificationCountStyle}>
          <span style={{ color: showNotifications && notificationCount !== 0 ? 'white' : 'black' }} className={classes.notificationCountStyleText}>
            {totalNotificationsCount}
          </span>
        </div>
      </div>
      {getSnoozeIcon()}
    </React.Fragment>
  );
};

export default NotificationBell;

NotificationBell.propTypes = {
  showNotifications: PropTypes.bool,
  notificationCount: PropTypes.number,
  notificationControlEnabled: PropTypes.bool,
  snoozeEnabled: PropTypes.bool,
  snoozeNotifications: PropTypes.func,
  totalNotificationsCount: PropTypes.number,
  setNotifications: PropTypes.func,
};

NotificationBell.defaultProps = {
  showNotifications: false,
  notificationCount: 0,
  notificationControlEnabled: false,
  snoozeEnabled: false,
  snoozeNotifications: () => { },
  totalNotificationsCount: 0,
  setNotifications: () => { },
};
